import { tokenAliasOrValue } from "./base";
import { ColorTokenData } from "./color";
import { OpacityTokenData } from "./opacity";
import { z } from "zod";
export const ShadowType = z.enum(["Drop", "Inner"]);
export const ShadowLayerValue = z.object({
    color: ColorTokenData,
    x: z.number(),
    y: z.number(),
    radius: z.number(),
    spread: z.number(),
    opacity: OpacityTokenData.optional(),
    type: ShadowType,
});
const ShadowTokenDataBase = tokenAliasOrValue(ShadowLayerValue);
export const ShadowValue = z.array(ShadowTokenDataBase);
export const ShadowTokenData = tokenAliasOrValue(z.array(ShadowTokenDataBase));
